import React, { Component } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import $ from 'jquery';
import IFrame from '../IFrame';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import { debuglog } from 'util';

class Tools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            APIBaseURL: null
        }
    }

    componentDidMount() {
        this.fetchData();
        $(".analytics-menu").click(e => {
            if ($('.collapseButton').hasClass("active")) {
                this.handleCollapse();
                $('.sidebar-submenu').show();
                $('body').toggleClass('sub-menu-active');
            }
        });
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function() {
                $(".collapseButton").removeClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 313 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function() {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function() {
                $(".collapseButton").addClass('active')
            });
            $(".tool-section").animate({
                marginLeft: 133 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    fetchData() {
        try {
            let wh_id = this.state.userdata.wholesaler_Id;
            let wh_email = this.state.userdata.email;
            userService.PaymentRails(wh_id, wh_email).then(
                apidata => {
                    if (apidata.length > 0) {
                        this.setState({ APIBaseURL: apidata[0].widgetLink });
                    }
                }

            );
        }
        catch (error) { }
    }
    render() {
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/' />
            }
            else if (usertype.toLowerCase() == 'admin') {
                return <Redirect to='/admin/tools' />
            }
        } catch (error) { }
        return (
            <div>
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar AnalyticList={this.props.AnalyticData} />
                <div className="tool-section manage-icon payment-section">
                    <h2>Payments <span className="beta-link"><span className="beta">Beta</span></span></h2>
                    {
                        this.state.APIBaseURL != null || this.state.APIBaseURL != '' ?
                            <IFrame url={this.state.APIBaseURL} />
                            :null
                     }
                    
                </div>
            </div>
        )

    }

}
export default Tools;